import axios from 'axios';

export default {
  getTeams: params => axios.get('/api/v1/avg/teams', { params }),
  getTeamByID: id => axios.get(`/api/v1/avg/teams/${id}`),
  createTeam: params => axios.post('/api/v1/avg/teams', params),
  updateTeam: (id, params) => axios.put(`/api/v1/avg/teams/${id}`, params),
  deleteTeams: params => axios.delete('/api/v1/avg/teams', { params }),
  getUsersLookup: () => axios.get('/api/v1/users')
};
